import { format } from 'date-fns'

// API devolve `Y-m-d H:i:s`; o `T` evita Invalid Date no Safari
export const formatDateTime = value => {
  if (!value) return '-'
  return format(new Date(value.replace(' ', 'T')), "dd/MM/yyyy 'às' HH:mm")
}

// Quill devolve `<p><br></p>` quando o editor está vazio
export const isEmptyHtml = (html = '') => {
  if (/<img/i.test(html)) return false
  return !html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, '')
    .trim()
}
